import { MAMEditorGuard } from "../../guards/permission.guard";
import { Routes } from "@angular/router";
import { SchedulerComponent } from "../scheduler/scheduler.component";
import { BlocksCalendarComponent } from "./blocks-calendar/blocks-calendar.component";

export const BlocksRoutes: Routes = [
  {
    path: "blocks",
    component: SchedulerComponent,
    canActivate: [MAMEditorGuard],
    children: [
      //{path: 'new', component: BlocksCalendarComponent},
      { path: "edit/:id", component: BlocksCalendarComponent },
      { path: "**", redirectTo: "/scheduler/calendar" },
    ],
  },
];
